import type { CMSQuickLinkTextCard } from '@/types/sanity'
import type React from 'react'
import {
  PortableText,
  type PortableTextReactComponents,
} from '@portabletext/react'
import { RichTextBlock } from '@/components/Sections/SectionRichText/RichTextBlock'

import styles from './TextCard.module.scss'

type QuickLinkTextCard = {
  card: CMSQuickLinkTextCard
  index: number | null
}

export const TextCard: React.FC<QuickLinkTextCard> = ({ card, index }) => {
  const { header, description } = card

  const portableTextComponents: Partial<PortableTextReactComponents> = {
    block: RichTextBlock,
    marks: {
      link: ({ children, value }) => {
        const { href } = value

        return (
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'underline' }}
          >
            {children}
          </a>
        )
      },
    },
    types: {},
  }

  return (
    <div className={styles.container}>
      <div className={styles.contentContainer}>
        {index && <p className="type-h2 md:type-h4">{index}</p>}
        <p className="type-label">{header}</p>
        <PortableText value={description} components={portableTextComponents} />
      </div>
    </div>
  )
}
